import EventEmitter from 'eventemitter3'

export enum EVENT_TYPE {
  OPEN_SESSION_DETAIL = 'OPEN_SESSION_DETAIL',
  APPLY_CALENDAR_FILTER = 'APPLY_CALENDAR_FILTER',
}

class EventBus {
  private _eventBusInstance: EventEmitter
  constructor() {
    this._eventBusInstance = new EventEmitter()
  }

  emit(eventName: string, data) {
    return this._eventBusInstance.emit(eventName, data)
  }

  on(eventName: string, callback = undefined) {
    return this._eventBusInstance.on(eventName, callback)
  }

  off(eventName: string, callback = undefined) {
    this._eventBusInstance.off(eventName, callback)
  }
}

export default new EventBus()
